import { useEffect, useState } from 'react';

export const useTimer = (totalTime: number) => {
  const [counter, setCounter] = useState<number>(totalTime);
  const [isStart, setStart] = useState<boolean>(false);

  useEffect(() => {
    let interval: any;
    if (isStart) {
      interval = setInterval(() => {
        setCounter(prev => Math.max(prev - 1, 0));
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isStart]);

  const start = () => {
    setStart(true);
  };

  const stop = () => {
    setStart(false);
  };

  return { counter, start, stop };
};
